<script setup>
const props = defineProps({
  title: { type: String, default: '' },
  url: { type: String, default: '' },
})

const { locale } = useI18n()
const localePath = useLocalePath()

const map = {
  stranka: 'article',
  oddeleni: 'department',
  zamestnanec: 'employee',
  aktualita: 'notice',
  publikace: 'publication',
}

const feURL = computed(() =>
  props.url.replace('https://avudev.avu.cz/', window.location.origin + '/')
)

const setLink = computed(() => {
  const url = props.url
  const slugArr = url.split('/')

  if (locale.value === 'cs' && slugArr[3] && slugArr[4]) {
    let resourceType = slugArr[3]

    resourceType = map[resourceType] || resourceType

    return { name: `${resourceType}-slug`, params: { slug: slugArr[4] } }
  }

  if (locale.value === 'en' && slugArr[4] && slugArr[5]) {
    const resourceType = slugArr[4]
    return { name: `${resourceType}-slug`, params: { slug: slugArr[5] } }
  }

  return { name: 'index' }
})

const type = computed(() => {
  const linkName = setLink.value.name

  if (linkName && linkName !== 'index') {
    const technicalName = linkName.split('-')[0]

    if (locale.value === 'cs') {
      const czechKey = Object.keys(map).find(
        (key) => map[key] === technicalName
      )

      return czechKey || technicalName
    }

    return technicalName
  }

  return ''
})
</script>

<template>
  <div class="result">
    <p>
      <span v-html="title"></span>
      <span class="capitalize"> | {{ type }}</span>
    </p>

    <NuxtLink class="link text_minor_3" :to="localePath(setLink)">
      {{ feURL }}
    </NuxtLink>
  </div>
</template>

<style lang="scss" scoped>
.result {
  border-bottom: 1px solid $color-5;
  padding-bottom: 19px;
  margin-bottom: 19px;
}

.capitalize {
  text-transform: capitalize;
}
</style>
